import { useMemo } from 'react';

import { useShowCause } from 'core/Api';
import { OrderBlock, OrderLineItem } from 'core/Components';
import { centsToDollar } from 'core/Utils';
import { useNavigate } from 'react-router-dom';
import { ConsumerCartItem } from 'store/Api';
import { Anchor, Card, Divider, Group, ImageMantine, Stack, Text } from 'ui';

type Props = {
  cartItem: ConsumerCartItem;
};
const PurchaseDetailSummaryCard = ({ cartItem }: Props) => {
  const { data: cause } = useShowCause(cartItem?.store_item?.cause_id);
  const navigate = useNavigate();

  const website = useMemo(
    () => cause?.links?.find((link) => link.type == 'website')?.url,
    [cause?.links]
  );

  return (
    <Card radius={8} p={0} bd="1px solid gray.1">
      <Stack gap={0}>
        <Group p={'md'} bg="gray.0" wrap="nowrap" align="top">
          <ImageMantine w={48} h={48} src={cause?.thumbnail?.url} radius={12} />
          <Stack gap={4}>
            <Anchor
              onClick={(e) => {
                e.preventDefault();
                navigate(`/causes/${cause?.uuid}`);
              }}
              href={`/causes/${cause?.uuid}`}
            >
              <Text fz={14} fw={600} c="gray.8">
                {cause?.name}
              </Text>
            </Anchor>

            {cause?.tax_id && (
              <Text fz={12} fw={400} c={'gray'}>
                EIN: {cause?.tax_id}
              </Text>
            )}

            {website && (
              <Text fz={12} fw={400} c={'gray'}>
                {website}
              </Text>
            )}
          </Stack>
        </Group>
        <Divider color="gray.1" />
        <Stack p={'md'}>
          <OrderBlock.Container>
            <OrderLineItem label="Subtotal" value={centsToDollar(cartItem?.total)} valueBold />
            {cartItem?.processing_fees == 'pass_on_fees' && (
              <OrderLineItem label="Fees" value={centsToDollar(cartItem?.fee)} valueBold />
            )}
            <OrderLineItem
              label="Item Total"
              value={
                cartItem?.processing_fees == 'pass_on_fees'
                  ? centsToDollar(cartItem?.total + cartItem?.fee)
                  : centsToDollar(cartItem?.total)
              }
              labelBold
              valueBold
            />
          </OrderBlock.Container>
        </Stack>
      </Stack>
    </Card>
  );
};

export { PurchaseDetailSummaryCard };
